/**
 * Created by Babu on 16/5/11.
 */

var $ = require("jquery");

var swipe = require('../vendor/swipe');

var stickUp2 = require("../vendor/stickUp");

var moment = require("moment");

moment.locale("zh-cn");

var ReactDOM = require("react-dom");

var ALikeStore = require("../store/ALikeStore");

var Dispatcher = require("../Dispatcher");

var {ActionConstants, ElementConstants, EventConstants} = require("../Constants");

var FilterMenu = require("../list-m/FilterMenu");
var PowerList = require("../list-m/PowerList");

$(function () {
    // use position:sticky in filter menu
    //$(".mod-target-filter").stickUp();

    var el = $('.js-sys-feature')
        ,   triggerList = el.find('.sys-triggers')
        ,   length = el.find('.sys-cell-tabs').length
        ,   str = '<div class="trigger"></div>'
        ;

    triggerList.html('<div class="trigger is-current"></div>' +Array(length).join(str));

    $('.js-sys-feature').Swipe({
        auto: false,
        continuous: true,
        callback: function(pos) {
            var triggers = el.find('.trigger');
            triggers.removeClass('is-current');
            triggers.eq(pos).addClass('is-current');
        }
    });

    /*******************/

    var locationData = SER_DATA['locationJson'] || {};

    var firstPage = $(".mod-super-list").html();

    Dispatcher.dispatch({type: ActionConstants.INIT_LOCATION_DATA, data: locationData});

    ReactDOM.render(<FilterMenu {...this.props} />, $(".mod-target-filter")[0]);

    ReactDOM.render(<PowerList firstPage={[firstPage]} />, $(".mod-super-list")[0]);

});


/** WEBPACK FOOTER **
 ** ./script/entry/list-m.js
 **/